import type {
  WidgetJSON,
  InlineInputJSON,
  DragOptionsJSON,
  InlineDragOptionJSON,
  RadioOptionsJSON,
  NumericKeypadJSON,
  FractionJSON,
  MatcherWidgetJSON,
  PairMatcherWidgetJSON,
  VisualFractionJSON,
} from '../../transformers/zod-schemas';

/**
 * Type guards for widget types
 * These help TypeScript properly narrow discriminated unions
 */

export function isInlineInputWidget(widget: WidgetJSON): widget is InlineInputJSON {
  return widget.type === 'inline-input';
}

export function isDragOptionsWidget(widget: WidgetJSON): widget is DragOptionsJSON {
  return widget.type === 'drag-options';
}

export function isInlineDragOptionWidget(widget: WidgetJSON): widget is InlineDragOptionJSON {
  return widget.type === 'inline-drag-option';
}

export function isRadioOptionsWidget(widget: WidgetJSON): widget is RadioOptionsJSON {
  return widget.type === 'radio-options';
}

export function isNumericKeypadWidget(widget: WidgetJSON): widget is NumericKeypadJSON {
  return widget.type === 'numeric-keypad';
}

export function isFractionWidget(widget: WidgetJSON): widget is FractionJSON {
  return widget.type === 'fraction';
}

export function isMatcherWidget(widget: WidgetJSON): widget is MatcherWidgetJSON {
  return widget.type === 'matcher';
}

export function isPairMatcherWidget(widget: WidgetJSON): widget is PairMatcherWidgetJSON {
  return widget.type === 'pair-matcher';
}

export function isVisualFractionWidget(widget: WidgetJSON): widget is VisualFractionJSON {
  return widget.type === 'visual-fraction';
}
